/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import BaseSocial from 'scripts/social/base';

export default BaseSocial.extend({
    init: function () {
        this._super();
        this.autoResolve = false;
        this.apiUrl = this.appConfig.urls.api.twitter.apiUrl;
    },

    isApiAvailable: function () {
        return !!window.twttr;
    },

    create: function (element, params, options) {
        this.initialize();
        this.socialAwaiting.then(function () {
            window.twttr.widgets.createTweet(params.socialID, this.$(element)[0], options);
        }.bind(this));
    },

    createTimeline: function (element, timelineId, options) {
        options = options || {};
        this.initialize();
        this.socialAwaiting.then(function () {
            window.twttr.widgets.createTimeline(
                timelineId,
                element,
                options
            );
        }.bind(this));
    },

    createShareButton: function (element, url, options) {
        this.initialize();
        this.socialAwaiting.then(() => {
            window.twttr.widgets.createShareButton(url, this.$(element)[0], options);
        });
    },

    onApiLoaded: function () {
        window.twttr.ready(
            (function () {
                this.socialAwaiting.resolve();
            }).bind(this)
        );
    }
}, {});
